import React from 'react';
import {
  IconButton,
  InputRightElement,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  Box,
  Icon,
} from '@podiumhq/design-system';

const FakeSideNav = () => {
  return (
    <Box
      display="flex"
      boxShadow="1px 0px 0px #e0e6ee"
      flexDirection="column"
      flex="0 0 256px"
      height="100%"
      padding="16px"
      position="relative"
      backgroundColor="#292E36"
    >
      <Box
        fontWeight="500"
        alignItems="center"
        display="flex"
        fontSize="16px"
        justifyContent="space-between"
        lineHeight="32px"
        marginBottom="5px"
        minHeight="32px"
        padding="0 2px 0 8px"
        color="#FFFFFF"
      >
        Inbox
      </Box>
      <Box
        alignItems="center"
        background="#4C76E0"
        border="1px solid transparent"
        borderRadius="8px"
        display="flex"
        fontSize="14px"
        lineHeight="32px"
        marginTop="2px"
        outline="none"
        padding="0 8px 0 4px"
      >
        <Icon
          marginLeft="4px"
          marginRight="8px"
          boxSize={5}
          color="silver.lightest"
          type="ChatBubbleEmpty"
        />
        <Box color="silver.lightest">All Conversations</Box>
      </Box>
      <Box
        alignItems="center"
        border="1px solid transparent"
        borderRadius="8px"
        display="flex"
        fontSize="14px"
        lineHeight="32px"
        marginTop="2px"
        outline="none"
        padding="0 8px 0 4px"
      >
        <Icon
          marginLeft="4px"
          marginRight="8px"
          boxSize={5}
          color="grey.lighter"
          type="UserAdd"
        />
        <Box color="grey.lighter">Unassigned</Box>
      </Box>
      <Box
        alignItems="center"
        border="1px solid transparent"
        borderRadius="8px"
        display="flex"
        fontSize="14px"
        lineHeight="32px"
        marginTop="2px"
        outline="none"
        padding="0 8px 0 4px"
      >
        <Icon
          marginLeft="4px"
          marginRight="8px"
          boxSize={5}
          color="grey.lighter"
          type="Mention"
        />
        <Box color="grey.lighter">Assigned to You</Box>
      </Box>
      <Text
        color="silver.lightest"
        fontSize="sm"
        fontWeight="medium"
        marginLeft="8px"
        marginTop="24px"
        marginBottom="8px"
      >
        INBOXES
      </Text>
      <Box
        alignItems="center"
        border="1px solid transparent"
        borderRadius="8px"
        display="flex"
        fontSize="14px"
        lineHeight="32px"
        marginTop="2px"
        outline="none"
        padding="0 8px 0 4px"
      >
        <Icon
          marginLeft="4px"
          marginRight="8px"
          boxSize={5}
          color="grey.lighter"
          type="Folder"
        />
        <Box color="grey.lighter">5 Star Reviews</Box>
      </Box>
      <Box
        alignItems="center"
        border="1px solid transparent"
        borderRadius="8px"
        display="flex"
        fontSize="14px"
        lineHeight="32px"
        marginTop="2px"
        outline="none"
        padding="0 8px 0 4px"
      >
        <Icon
          marginLeft="4px"
          marginRight="8px"
          boxSize={5}
          color="grey.lighter"
          type="Folder"
        />
        <Box color="grey.lighter">Feedback</Box>
      </Box>
      <Box
        marginTop="36px"
        fontWeight="500"
        alignItems="center"
        display="flex"
        fontSize="16px"
        justifyContent="space-between"
        lineHeight="32px"
        marginBottom="5px"
        minHeight="32px"
        padding="0 2px 0 8px"
        color="#FFFFFF"
      >
        Team
      </Box>
      <InputGroup size="sm">
        <InputLeftElement>
          <Icon type="Search" marginLeft="12px" color="silver.base" />
        </InputLeftElement>
        <Input
          placeholder="Search"
          type="search"
          marginLeft="8px"
          backgroundColor="black.lightest"
          borderColor="black.lightest"
          size="sm"
          tabIndex="-1"
        />
        <InputRightElement>
          <IconButton type="XCircle" variant="ghost" tabIndex="-1" />
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

export default FakeSideNav;
